var React = require('react');

function Tablet1Light (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 5a5 5 0 015-5h26a5 5 0 015 5v38a5 5 0 01-5 5H11a5 5 0 01-5-5V5zm2 5v27h32V10H8zm32-2H8V5a3 3 0 013-3h26a3 3 0 013 3v3zm0 31H8v4a3 3 0 003 3h26a3 3 0 003-3v-4zm-16 2a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"}));
}

Tablet1Light.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Tablet1Light;

Tablet1Light.default = Tablet1Light;
